import { useRef } from "react";
import "./DashboardNavbarMobile.css";
import Logo from "../../assets/logoNew.png";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";
import CustomButton from "../customButton/CustomButton";
import { BsArrowRight } from "react-icons/bs";
import { config } from "../../config";
import { persistLogout } from "../../store/store";
import { useTypedSelector } from "../../hook/useTypedSelector";
import { useAuthQuery } from "../../store/query/auth";
import { FaCheck } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import { RiPassPendingFill } from "react-icons/ri";

const DashboardNavbarMobile = ({ navList, user }) => {
  const navRef = useRef();
  const navigate = useNavigate();
  const { token } = useTypedSelector((store) => store.appUser);
  const profilePics = user?.profile_pix
    ? `${config.getPublicImages}/${user?.profile_pix}`
    : "https://static.vecteezy.com/system/resources/thumbnails/002/534/006/small/social-media-chatting-online-blank-profile-picture-head-and-body-icon-people-standing-icon-grey-background-free-vector.jpg";

  const toggleNavbar = () => {
    navRef.current.classList.toggle("responsive_nav_das");
  };

  const { data: auth } = useAuthQuery({
    token: token,
    acc_type: user?.account_type,
  });

  const btnStyled = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "8px 25px",
  };

  return (
    <div className="bg-nav-mobile">
      <div className="nav-container-das">
        <div className="header-das">
          <Link to="/" className="nav_title">
            <img src={Logo} alt="logo-freelancemedic" />
          </Link>

          <nav ref={navRef}>
            <div className="nav-bar-con">
              <div className="first-items">
                {navList?.map((nav) =>
                  nav.hide ? null : (
                    <NavLink
                      key={nav.name}
                      to={nav.to}
                      className={(navClass) =>
                        navClass.isActive ? "profile-active" : "profile-dom"
                      }
                      onClick={() => {
                        if (nav.name === "Logout") persistLogout();
                        toggleNavbar();
                      }}
                    >
                      <div className="profile-button">
                        {nav.icon}
                        <span>{nav.name}</span>
                      </div>
                    </NavLink>
                  )
                )}
              </div>

              <CustomButton
                title={
                  <>
                    <div style={btnStyled}>
                      Find Jobs <BsArrowRight />
                    </div>
                  </>
                }
                onClick={() => {
                  navigate("/shortlist");
                  toggleNavbar();
                }}
              />

              <div className="box-2">
                <div className="first">
                  <img src={profilePics} alt="logo" className="profile-pics" />

                  <div className="box-2-text">
                    <div className="widget-box">
                      <span>{user?.name}</span>
                      {auth?.data?.status === 2 ||
                      auth?.data?.status === "2" ||
                      user?.status === 2 ||
                      user?.status === "2" ? (
                        <div className="tooltip-icon bag" data-tooltip="ACTIVE">
                          <FaCheck color="#fff" size={12} />
                        </div>
                      ) : auth?.data?.status === 4 ||
                        auth?.data?.status === "4" ||
                        user?.status === 4 ||
                        user?.status === "4" ? (
                        <div className="tooltip-icon" data-tooltip="INACTIVE">
                          <ImCancelCircle color="red" size={15} />
                        </div>
                      ) : (
                        <div
                          className="tooltip-icon pending"
                          data-tooltip="PENDING"
                        >
                          <RiPassPendingFill color="#fff" size={12} />
                        </div>
                      )}
                    </div>
                    <h5>
                      {user?.account_type === "organisation"
                        ? "Org"
                        : user?.division?.name}
                    </h5>
                  </div>
                </div>
              </div>
            </div>

            <button className="nav-btn nav-close-btn" onClick={toggleNavbar}>
              <FaTimes />
            </button>
          </nav>

          <div>
            <button className="nav-btn" onClick={toggleNavbar}>
              <FaBars />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardNavbarMobile;
